import { Icon } from "@Rolec-Services/rolec-ui";
import { TFunction } from "i18next";
import { TableProps } from "./table";
import { TierProps } from "./tier";

type TierData = {
  tiers: TierProps[];
  info: TableProps["info"];
};

export function TierData(t: TFunction): TierData {
  return {
    tiers: [
      {
        src: "/assets/home.svg",
        heading: t("Basic"),
        content: t(
          "Charging at home, visitor can only charge with own Monta account. (Maximum 3 charging points)"
        ),
      },
      // {
      //   src: "/assets/sponsored.svg",
      //   heading: t("Sponsored"),
      //   content: t(
      //     "Charging at home with automatic settlement between employer and employee."
      //   ),
      // },
      {
        src: "/assets/commercial.svg",
        heading: t("Commercial"),
        content: t(
          "The best solution for commercial charging for both companies and private individuals with all functionalities."
        ),
      },
    ],
    info: {
      headings: [
        t("Costs"),
        t("Basis (incl. VAT)"),
        // t("Sponsored (excl. VAT)"),
        t("Commercial (excl. VAT)"),
      ],
      content: [
        t("Subscription"),
        t("Free"),
        // t("€ 7,44"),
        t("€ 7,44"),
        t("Paid charging session"),
        // t("0.24 starting rate and 7.5% per transaction"),
        t("0.20 starting rate and 7.5% per transaction"),
        t("0.20 starting rate and 7.5% per transaction"),
        // t("Free or sponsored charging session"),
        t("0.24 starting rate, no transaction costs"),
        t("0.20 starting rate, no transaction costs"),
        t("0.20 starting rate, no transaction costs"),
      ],
    },
  };
}

export function CompareData(t: TFunction) {
  return [
    t("Subscription"),
    t("Free"),
    // t("Free"),
    // t("€7.44 per month, per socket"),
    t("€7.44 per month, per socket"),

    t("Paid charging session costs"),
    t("0.24 starting rate and 15% transaction costs"),
    // t("0.20 starting rate and 7.5% transaction costs"),
    // "-",
    t("0.20 starting rate and 7.5% transaction costs"),

    t("Costs sponsored or free charging session"),
    t("0.24 starting rate, no transaction costs"),
    // t("0.20 starting rate, no transaction costs"),
    // t("0.20 starting rate, no transaction costs"),
    t("0.20 starting rate, no transaction costs"),

    t("Optional: 4G Connectivity"),
    t("€3.63 per month, per socket"),
    // "-",
    // t("€3.00 per month, per socket"),
    t("€3.00 per month, per socket"),

    t("Email support (In Monta, English)"),
    <Icon icon="Check" />,
    // <Icon icon="Check" />,
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Portal"),
    <Icon icon="Check" />,
    // <Icon icon="Check" />,
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Dashboard"),
    "",
    // "",
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Transaction Overview"),
    "",
    // "",
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Unlimited in team members"),
    "",
    // "",
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Roaming: public charging for everyone"),
    "",
    // "",
    // "",
    <Icon icon="Check" />,

    t("Loading for other Monta users"),
    <Icon icon="Check" />,
    // <Icon icon="Check" />,
    // "",
    <Icon icon="Check" />,

    t("Pay with your team Wallet"),
    "",
    // "",
    // "",
    <Icon icon="Check" />,

    t("Charging drops for team"),
    <Icon icon="Check" />,
    // <Icon icon="Check" />,
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Pay afterwards (per month)"),
    "",
    // "",
    // <Icon icon="Check" />,
    <Icon icon="Check" />,

    t("Loading balancing"),
    <Icon icon="Check" />,
    // <Icon icon="Check" />,
    // "",
    <Icon icon="Check" />,
  ];
}
